<template>
    <div v-if="componentLoader" class="position-relative h-100">
      <app-overlay-loader />
    </div>
    <div v-else>
      <app-overlay-loader v-if="preloader" />
      <div class="company_detail_info">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
  </template>
  
  <script>
  import GlobalHelperMixin from "../../../../Mixins/global/GlobalHelperMixin";
  import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
  import { UserMixin } from "./../Mixins/UserMixin";
  import AppLibrary from "../../../../Helpers/AppLibrary";
  
  export default {
    name: "CompanyBusinessDetail",
    extends: AppLibrary,
    mixins: [FormMixin, UserMixin, GlobalHelperMixin],
    data() {
      return {
        icon: "settings",
        tabsHorizontal: [
           {
            name: "Contacts",
            component: "company-contacts",
            permission: "",
            props: {company_id: this.$attrs['props'].companyId}
          },
          {
            name: "Offices",
            component: "company-offices",
            permission: "",
            props: {company_id: this.$attrs['props'].companyId}
          },
          {
            name: "Headcount Details",
            component: "company-headcounts",
            permission: "",
            props: {company_id: this.$attrs['props'].companyId}
          },
          {
            name: "Insurances",
            component: "company-insurance",
            permission: "",
            props: {company_id: this.$attrs['props'].companyId}
          },
          {
            name: "Turnover Details",
            component: "company-turnovers",
            permission: "",
            props: {company_id: this.$attrs['props'].companyId}
          },
          {
            name: "Accreditation Details",
            component: "company-accreditations",
            permission: "",
            props: {company_id: this.$attrs['props'].companyId}
          },

        ],
        preloader: false,
      };
    },
    methods: {
    },
    mounted() {
    },
  };
  </script>
  